import React, { useState } from "react";
import Main from "./Main";
import AppBreadcrumbs from "../components/ui/AppBreadcrumbs";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DownloadIcon from "@mui/icons-material/Download";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CloseIcon from "@mui/icons-material/Close";
const GeneratedReports = () => {
  const [openForm, setOpenForm] = useState(false);
  const reportTypes = [
    "AZORPAY PG",
    "V1.0 RAZOR",
    "PAY PG",
    "V2.0 RAZOR",
    "V3.0 PAYU PG",
    "V2.0 PAYU PG",
    "V3.0 MONEY TRANSFER PG",
    "SETTLEMENT",
  ];
  const generateReportFor = [
    "FOR MINE BUSINESS",
    "FOR ALL (MINE + OTHERS) BUSINESS",
    "FOR ALL OTHERS BUSINESS",
    "SDA115476 - VIKASH KUMAR SHAU",
  ];
  const months = [
    "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
    "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
  ];
  const years = ["2021", "2022", "2023", "2024", "2025", "2026"];
  return (
    <Main showRightPanel={false}>
      <div className="mt-4 font-[Poppins]">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Reports" },
            { label: "Generated Report" },
          ]}
        />
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mt-2 mb-2 sm:mt-4 sm:mb-4">
  <div className="flex justify-end gap-3 sm:gap-2 order-1 sm:order-none">
    <button
      type="button"
      onClick={() => setOpenForm(true)}
      className="ds-action-btn">
      <AddOutlinedIcon fontSize="small" />
      <span className="hidden sm:inline">Create New Reports Request</span>
    </button>
    <button
      type="button"
      className="ds-action-btn">
      <DownloadIcon fontSize="small" />
      <span className="hidden sm:inline">Report Download</span>
    </button>
  </div>
</div>
        <div className="ds-table-wrap ds-scroll">
          <table className="ds-table text-[10px] sm:text-xs">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Report Type</th>
                <th>Report Name</th>
                <th>Report Month</th>
                <th>Report Year</th>
                <th>Report Period</th>
                <th>Requested Date</th>
                <th>Completion Date</th>
                <th>Report Status</th>
              </tr>
            </thead>
            <tbody>
              <tr className="whitespace-nowrap">
                <td>#1</td>
                <td>RAZORPAY PG V3</td>
                <td>
                  RAZORPAY PG V3 <br />
                  (01ST MAY 2025 TO 31st MAY 2025)
                </td>
                <td>MAY</td>
                <td>2025</td>
                <td>
                  01/05/2025 <br /> 31/05/2025
                </td>
                <td>
                  28-07-2025 <br /> 08:13:15 PM
                </td>
                <td>
                  28-07-2025 <br /> 08:10:41 PM
                </td>
                <td>
                  <CheckCircleIcon sx={{ color: "var(--success-color)" }} />
                </td>
              </tr>
              <tr className="whitespace-nowrap">
                <td>#2</td>
                <td>RAZORPAY PG V3</td>
                <td>
                  RAZORPAY PG V3 <br />
                  (01ST JULY 2025 TO 28TH JULY 2025)
                </td>
                <td>JULY</td>
                <td>2025</td>
                <td>
                  01/07/2025 <br /> 28/07/2025
                </td>
                <td>
                  28-07-2025 <br /> 08:11:58 PM
                </td>
                <td>
                  28-07-2025 <br /> 08:12:01 PM
                </td>
                <td>
                  <CheckCircleIcon sx={{ color: "var(--success-color)" }} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {openForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] px-3">
          <div className="relative ds-modal w-full max-w-sm 
                          max-h-[90vh] overflow-y-auto ds-scroll">
            <button
              type="button"
              onClick={() => setOpenForm(false)}
              className="absolute right-3 top-3 text-[var(--text-muted)]">
              <CloseIcon />
            </button>
            <h2 className="text-sm font-bold mb-3 text-[var(--text-dark)]">
              CREATE NEW REPORT REQUEST
            </h2>
            <div className="space-y-3 text-xs">
              <div>
                <label className="ds-label">
                  Report Type <span className="text-[var(--error-color)]">*</span>
                </label>
                <select className="ds-input mt-1">
                  <option>Select Report Type</option>
                  {reportTypes.map((t) => (
                    <option key={t}>{t}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="ds-label">
                  Generate Report For <span className="text-[var(--error-color)]">*</span>
                </label>
                <select className="ds-input mt-1">
                  <option>Select Generate Report For</option>
                  {generateReportFor.map((t) => (
                    <option key={t}>{t}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="ds-label">
                  Report Month <span className="text-[var(--error-color)]">*</span>
                </label>
                <select className="ds-input mt-1">
                  <option>Select Report Month</option>
                  {months.map((m) => (
                    <option key={m}>{m}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="ds-label">
                  Report Year <span className="text-[var(--error-color)]">*</span>
                </label>
                <select className="ds-input mt-1">
                  <option>Select Report Year</option>
                  {years.map((y) => (
                    <option key={y}>{y}</option>
                  ))}
                </select>
              </div>
              <div className="flex justify-between mt-4 gap-3">
                <button
                  type="button"
                  onClick={() => setOpenForm(false)}
                  className="ds-btn ds-btn-secondary flex-1">
                  Cancel
                </button>
                <button type="button" className="ds-btn ds-btn-primary flex-1">
                  Submit Request
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Main>
  );
};
export default GeneratedReports;
